export default class personalisedSlider {
  constructor() {
    this.module = document.querySelector('[data-personalised-slider]');

    if (this.module) {
      this.unpersonalised = [...this.module.querySelectorAll('[data-unpersonalised]')];
      this.personalised = [...this.module.querySelectorAll('[data-personalised]')];
      this.allAnswers = document.getElementsByName('personal_result');

      this.responsesSet1 = [...this.module.querySelectorAll('[data-response-set1]')];
      this.responsesSet2 = [...this.module.querySelectorAll('[data-response-set2]')];
    }

    this.activeQ1 = null;
    this.activeQ2 = null;
    this.activeQ3 = null;
  }

  init() {
    if (!this.module) {
      return this;
    }

    this.showResponses();

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-option]')) {
        this.toggleOption(e.target);
      }
    });

    return this;
  }

  toggleOption(option) {
    const blockOptions = [...option.parentNode.querySelectorAll('[data-option]')];

    if (option.classList.contains('-active')) {
      option.classList.remove('-active');
      option.classList.remove('button-primary');
      option.classList.add('button-secondary');
    } else {
      blockOptions.forEach((blockoption) => {
        blockoption.classList.remove('-active');
        blockoption.classList.remove('button-primary');
        blockoption.classList.add('button-secondary');
      });

      option.classList.remove('button-secondary');
      option.classList.add('button-primary');
      option.classList.add('-active');
    }

    this.showResponses();

    return this;
  }

  showResponses() {
    // Set responses
    this.activeQ1 = (this.module.querySelector('[data-q1-option].-active')) ? this.module.querySelector('[data-q1-option].-active').dataset.q1Option : null;
    this.activeQ2 = (this.module.querySelector('[data-q2-option].-active')) ? this.module.querySelector('[data-q2-option].-active').dataset.q2Option : null;
    this.activeQ3 = (this.module.querySelector('[data-q3-option].-active')) ? this.module.querySelector('[data-q3-option].-active').dataset.q3Option : null;

    // Hide all responses
    this.responsesSet1.forEach((response) => {
      response.classList.add('_hidden');
    });
    this.responsesSet2.forEach((response) => {
      response.classList.add('_hidden');
    });

    // Show active responses
    this.responsesSet1.forEach((response) => {
      if (response.dataset.responseSet1.includes(`${this.activeQ1}_${this.activeQ2}`)) {
        response.classList.remove('_hidden');
      }
    });
    this.responsesSet2.forEach((response) => {
      if (response.dataset.responseSet2.includes(`${this.activeQ3}`)) {
        response.classList.remove('_hidden');
      }
    });

    // Show/hide default text
    if (this.activeQ1 != null && this.activeQ2 != null && this.activeQ3 != null) {
      this.module.classList.add('-personalised');

      this.personalised.forEach((item) => {
        item.classList.remove('_hidden');
      });

      this.unpersonalised.forEach((item) => {
        item.classList.add('_hidden');
      });
    } else {
      this.module.classList.remove('-personalised');

      this.personalised.forEach((item) => {
        item.classList.add('_hidden');
      });

      this.unpersonalised.forEach((item) => {
        item.classList.remove('_hidden');
      });
    }

    // Push answers into text field
    if (this.allAnswers[0]) {
      this.allAnswers[0].value = `${this.activeQ1}, ${this.activeQ2}, ${this.activeQ3}`;
    }
  }
}
